// import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpGetCart } from '../../Hooks/user/user.get.hooks';
import PropTypes from 'prop-types';
import Auth from '../../Helpers/auth';

// For the cart
const CartDataProvider = ({ children }) => {
  const { data } = Auth.getProfile();
  const userId = data?.id || localStorage?.getItem('temp_id');
  const {
    data: cart,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['cart'],
    queryFn: () => httpGetCart(userId),
    enabled: !!userId,
    retry: 2,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  if (!userId) {
    return children([]);
  }

  if (isLoading) return children([]);
  if (isError) return children([]);
  // console.log('CartDataProvider cart', cart);

  return children(cart);
};
CartDataProvider.propTypes = {
  //   userId: PropTypes.string,
  //   courseId: PropTypes.string,
  children: PropTypes.func,
};

export default CartDataProvider;
